import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

interface IRemoveVehicleTypeProps extends RouteComponentProps {
  setting: { label: string; id: string }
  id: string
  removeVehicleType: (id: string) => Promise<any>
}

export default class RemoveVehicleTypeModal extends React.Component<IRemoveVehicleTypeProps> {
  public render() {
    return (
      <SettingRemoveModal
        setting={this.props.setting ? this.props.setting : { label: '', id: '' }}
        settingType='Vehicle Type'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    this.props.removeVehicleType(this.props.id).then(() => {
      setTimeout(() => {
        this.onClose()
      }, 1000)
    })
  }

  private onClose = () => {
    this.props.history.push('/global-settings/vehicle-type')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveVehicleTypeModal.tsx